import React from "react";
import HeroSection from "./HeroSection";
import RoyellaBookingArea from "./RoyellaBookingArea";
import RoomTitleArea from "./RoomTitleArea";
import AboutArea from "./AboutArea";
import RoomArea from "./RoomArea";
import FeatureArea from "./FeatureArea";
import ManagerCallDoArea from "./ManagerCallDoArea";
import ServicesArea from "./ServicesArea";
import OffersArea from "./OffersArea";
import TestimonialArea from "./TestimonialArea";
import BlogArea from "./BlogArea";

const Home = () => {
  return (
    <>
      <HeroSection />
      <RoyellaBookingArea />
      <AboutArea />
      <RoomTitleArea />
      <RoomArea />
      <FeatureArea />
      <ManagerCallDoArea />
      <ServicesArea />
      <OffersArea />
      <TestimonialArea />
      <BlogArea />
    </>
  );
};

export default Home;
